export default {
  title: 'Váš košík',
  purchaseLimit: 'Limit nákupu:',
  emptyTitle: 'Váš košík je prázdný',
  emptyText: 'Projděte si katalog a přidejte si herní klíče, abyste mohli začít.',
  browseCatalog: 'Procházet katalog',
  removeItem: 'Odebrat položku',
  continueShopping: 'Pokračovat v nákupu',
  orderSummary: 'Souhrn objednávky',
  items: 'Položky ({n})',
  fees: 'Poplatky',
  total: 'Celkem',
  proceedToCheckout: 'Pokračovat k pokladně',
  limitReached: 'dosažen limit objednávky',
};
